import React from 'react';
import { useHistory } from 'react-router-dom';
import EmployeeFrame from './EmployeeFrame';
import { Button } from '../../ui/button';
import { Clock, ShieldCheck, Smartphone, Leaf } from 'lucide-react';

const Welcome = () => {
  const history = useHistory();
  return (
    <EmployeeFrame client='Unlimited Group'>
      <div className='flex flex-col py-6'>
        <div className='w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center text-accent mb-5 mx-auto'>
          <Leaf size={26} strokeWidth={1.5} />
        </div>
        <h1 className='font-display text-2xl text-center leading-tight mb-3'>
          Help us measure our footprint
        </h1>
        <p className='text-[15px] text-muted-foreground text-center leading-relaxed mb-6'>
          A short survey about your working pattern, home office, and commute. Takes about 5 minutes on mobile or
          desktop.
        </p>

        <div className='space-y-3 mb-8'>
          <div className='flex items-start gap-3'>
            <div className='w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center text-accent flex-shrink-0'>
              <Clock size={16} strokeWidth={1.5} />
            </div>
            <div>
              <div className='text-sm font-medium'>Under 10 minutes</div>
              <div className='text-xs text-muted-foreground'>
                You can save progress and come back later if you need to grab info (like your car fuel type).
              </div>
            </div>
          </div>
          <div className='flex items-start gap-3'>
            <div className='w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center text-accent flex-shrink-0'>
              <Smartphone size={16} strokeWidth={1.5} />
            </div>
            <div>
              <div className='text-sm font-medium'>Mobile friendly</div>
              <div className='text-xs text-muted-foreground'>
                Works well on phones — no login or account needed.
              </div>
            </div>
          </div>
          <div className='flex items-start gap-3'>
            <div className='w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center text-accent flex-shrink-0'>
              <ShieldCheck size={16} strokeWidth={1.5} />
            </div>
            <div>
              <div className='text-sm font-medium'>Only shared with your employer</div>
              <div className='text-xs text-muted-foreground'>
                Your answers are only used to calculate aggregate company emissions for sustainability reporting.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='space-y-2'>
        <Button size='xl' className='w-full' onClick={() => history.push('/prototype/wfh-survey/employee/step/employment')}>
          Start the survey
        </Button>
        <div className='text-center text-[11px] text-muted-foreground'>
          This link is personal to you — please don't forward it.
        </div>
      </div>
    </EmployeeFrame>
  );
};

export default Welcome;
